export default __webpack_public_path__ + "static/media/product-1.79ae1d8c.jpg";